const notifications = {
  title: "الاشعارات",
  allNotifications: "جميع الاشعارات",
  markAsRead: "تحديد كمقروء",
  seeAllNotifications: "مشاهدة جميع الاشعارات",
  seeMore: "مشاهدة المزيد",
  loadMore: "تحميل المزيد من الاشعارات",
  unreadCount: "{count} غير مقروء",
  allRead: "الكل مقروء",
  allCaughtUp: "لقد اطلعت على كل الاشعارات",
  emptyDescription: "لا توجد اشعارات بعد. سنعلمك فور وصول أي جديد.",
  today: "اليوم",
  yesterday: "أمس",
  earlier: "الأقدم",
  noNotifications: "لا توجد اشعارات حاليا",
  notificationsSupportAlert:
    "يرجى ملاحظة أن الإشعارات غير مدعومة في إصدار متصفحك الحالي، يرجى التحديث إلى الإصدار الأحدث",
};

export default notifications;
